if (typeof Mapa !== " function") {
  //-drop fields=contagios,tasa_contagios
  window.Mapa = function (wrapper, duracion, formato, data) {
    let box = new Box({
      size: { width: 1600, height: 1400 },
      padding: 10,
    });

    let projection = d3.geoMercator();
    let path = d3.geoPath();

    let svg = null;
    let gMapa = null;
    let gEstados = null;
    let gLeyenda = null;

    let estados = data.estados;

    const color = d3.scaleSymlog().range(["#ffffff", "#ff0000"]);

    function setup() {
      fetchData();
    }

    function fetchData() {
      let url = wrapper.attr("data-csv");
      Promise.all([
        d3.csv(url, function (d) {
          return { estado: d.estado, casos: +d.contagios };
        }),
      ]).then(function ([csv]) {
        _.each(data.estados.objects.estados.geometries, function (estado) {
          let nombreEstado = estado.properties.NOM_ENT;
          let csvEstado = _.find(csv, { estado: nombreEstado }) || false;
          if (csvEstado) {
            estado.properties.contagios = csvEstado.casos;
            estado.properties.tasa_contagios =
              (estado.properties.contagios * 100000) /
              estado.properties.poblacion;
          }
        });
        crearSVG(wrapper);
        procesarDatos();
        crearMapa();
        crearLeyenda();
      });
    }

    function crearSVG(wrapper) {
      wrapper.style("container-type", "inline-size");

      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top - 120})`,
        );

      gMapa = svg.append("g").attr("data-g", "gMapa");

      gEstados = gMapa
        .append("g")
        .attr("stroke", "#b8b8b8ff")
        .attr("stroke-width", 1)
        .attr("fill", "transparent")
        .attr("data-g", "gEstados");

      gLeyenda = svg.append("g").attr("data-g", "gLeyenda");
    }

    function procesarDatos() {
      let arreglo = _.map(
        estados.objects.estados.geometries,
        (d) => d.properties.tasa_contagios,
      );
      arreglo = _.filter(arreglo, (d) => d != null);
      color.domain([0, d3.max(arreglo)]);
    }

    function crearMapa() {
      estados = topojson.feature(estados, estados.objects.estados);
      estados = estados.features;

      let obj = {
        type: "FeatureCollection",
        features: estados,
      };

      projection.fitSize([box.content.width, box.content.height], obj);
      path.projection(projection);

      gEstados
        .selectAll("path")
        .data(estados)
        .enter()
        .append("path")
        .attr("d", path)
        .attr("fill", function (d) {
          let c = null;
          if (d.properties.tasa_contagios != null) {
            c = color(Math.ceil(d.properties.tasa_contagios));
          }
          return c;
        })
        .on("mouseover", crearTooltip)
        .on("mouseout", deshacerTooltip);
    }

    function crearLeyenda() {
      gLeyenda
        .attr("transform", "translate(450,1300)")
        .style("stroke-width", "2px");

      let rect = gLeyenda.append("rect").style("fill", "#ffffff");

      let arreglo = [0, 1, 5, 10, 50, 100];
      let l = 100;
      let x = 0;

      let texto = gLeyenda
        .append("text")
        .attr("data-tipo", "leyenda")
        .text("Tasa por cada cien mil habitantes")
        .attr("x", (arreglo.length * l) / 2)
        .attr("y", -50)
        .attr("text-anchor", "middle");

      let style = getComputedStyle(texto.node());
      let fs = parseInt(style["font-size"]);

      texto.attr("y", -fs);

      _.each(arreglo, function (d) {
        gLeyenda
          .append("rect")
          .attr("data-tipo", "leyenda")
          .attr("width", l)
          .attr("height", l)
          .attr("x", x)
          .attr("y", fs)
          .style("fill", color(d))
          .style("stroke", "#b8b8b8");

        gLeyenda
          .append("text")
          .attr("data-tipo", "leyenda")
          .text(d)
          .attr("x", x + l / 2)
          .attr("y", fs - 10)
          .attr("text-anchor", "middle");

        x += l;
      });

      let caja = gLeyenda.node().getBBox();
      rect
        .attr("x", caja.x - 10)
        .attr("y", caja.y - 10)
        .attr("width", caja.width + 20)
        .attr("height", caja.height + 20);
    }

    function crearTooltip(e, d) {
      if (d.properties.contagios != null) {
        let entidad =
          d.properties.NOM_ENT == "México"
            ? "Estado de México"
            : d.properties.NOM_ENT;
        let [x, y] = d3.pointer(e, this);
        let el = d3.select(this);
        let cajaPath = el.node().getBBox();
        y = cajaPath.y;

        el.raise().style("stroke-width", "2px").style("stroke", "#000000");

        let gTooltip = svg.append("g").attr("class", "tooltip ignore");

        let rect = gTooltip
          .append("rect")
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", 0)
          .attr("height", 0)
          .style("fill", "#ffffff")
          .style("stroke", "gray")
          .style("stroke-width", "2px");

        let text = gTooltip
          .append("text")
          .attr("x", 0)
          .attr("y", 0)
          .attr("dy", 0)
          .attr("text-anchor", "middle");

        text.append("tspan").attr("class", "entidad").text(`${entidad}`);

        let style = getComputedStyle(text.node());
        let fs = parseInt(style["font-size"]);

        text
          .append("tspan")
          .attr("x", 0)
          .attr("y", formato == "horizontal" ? fs + 10 : fs + 20)
          .attr("class", "cantidad")
          .text(`${d.properties.tasa_contagios.toFixed(2)}`);
        text.append("tspan").text(` contagios por cada 100,000 habitantes`);

        let caja = text.node().getBBox();

        y -= caja.height - 10;
        y = y <= 200 ? 200 : y;

        rect
          .attr("x", caja.x - 10)
          .attr("y", caja.y - 10)
          .attr("width", caja.width + 20)
          .attr("height", caja.height + 20);

        let overflow = x + (caja.x - 10) + (caja.width + 20);
        let underflow = x - (caja.x - 10 + (caja.width + 20));
        let width = caja.width + 20;

        if (overflow > box.content.width) {
          gTooltip.attr(
            "transform",
            `translate(${box.content.width - width / 2}, ${y})`,
          );
        } else if (underflow < 0) {
          gTooltip.attr("transform", `translate(${0 + width / 2}, ${y})`);
        } else {
          gTooltip.attr("transform", `translate(${x}, ${y})`);
        }
      }
    }

    function deshacerTooltip(e, d) {
      let el = d3.select(this);
      el.style("stroke-width", null).style("stroke", null);
      svg.selectAll("g.tooltip").remove();
    }

    setup();
  };
}
